import { useEffect, useState } from 'react';
import Header from '../../components/Header/Header';
import './Settings.scss';
import SettingsUserProfile from './SettingsUserProfile';
import SettingsUserPermission from './SettingsUserPermission';
import SettingsUserSecurity from './SettingsUserSecuirty';
import { useNavigate } from 'react-router-dom';

const Settings = () => {
  const [activeTab, setActiveTab] = useState<'profile' | 'roles-and-permissions' | 'security'>('profile');
  const navigate = useNavigate();

  const [rolesAndPermissionsAction, setRolesAndPermissionsAction] = useState<null | {
    type: 'invite' | 'view-roles';
    timeStamp: number;
    payload?: any;
  }>(null);

  useEffect(() => {
    navigate(`/settings?tab=${activeTab}`);
  }, [activeTab]);

  const usersRoleId: string = localStorage.getItem('userRoleID') ?? '';

  const isSuperAdmin = usersRoleId === '5a90f7ac-4a64-47c3-8a47-9b02174b789a';

  return (
    <>
      <Header name="Settings" />
      <div className="settings-page">
        <div className="settings-page__body">
          <div className="settings-page__body-header">
            <div className="tabs-container">
              <div
                className={`tab-buttons ${activeTab === 'profile' && 'active-tab'}`}
                onClick={() => {
                  setActiveTab('profile');
                }}
              >
                User Profile
              </div>
              {isSuperAdmin && (
                <div
                  className={`tab-buttons ${activeTab === 'roles-and-permissions' && 'active-tab'}`}
                  onClick={() => setActiveTab('roles-and-permissions')}
                >
                  Role & Permission
                </div>
              )}
              <div
                className={`tab-buttons ${activeTab === 'security' && 'active-tab'}`}
                onClick={() => setActiveTab('security')}
              >
                Security Settings
              </div>
            </div>

            <div className="actions-container">
              {activeTab === 'roles-and-permissions' && (
                <>
                  <button
                    onClick={() =>
                      setRolesAndPermissionsAction({
                        type: 'invite',
                        timeStamp: new Date().getTime(),
                      })
                    }
                  >
                    Invite Admin
                  </button>
                  <button
                    onClick={() =>
                      setRolesAndPermissionsAction({
                        type: 'view-roles',
                        timeStamp: new Date().getTime(),
                      })
                    }
                  >
                    View Roles
                  </button>
                </>
              )}
            </div>
          </div>

          <div className={`settings-page__body-section ${activeTab}`}>
            {activeTab === 'profile' && <SettingsUserProfile />}
            {activeTab === 'roles-and-permissions' && <SettingsUserPermission action={rolesAndPermissionsAction} />}
            {activeTab === 'security' && <SettingsUserSecurity />}
          </div>
        </div>
      </div>
    </>
  );
};

export default Settings;
